import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {State} from 'vuex-class';
import {ServiceTransactionInitState} from '@/store/service-transaction/service-transaction.types';

@Component({
  components: {}
})
export default class PaymentMenuComponent extends Vue {
  @State('serviceTransaction') serviceTransactionInitState!: ServiceTransactionInitState;

  mounted() {
  }

  jobIsRunning() {
    if (this.serviceTransactionInitState.jobIsRunning) {
      this.$router.push('/payment-information').then();
      return true;
    }
    return false;
  }
  ServiceProviderClick() {
    if(!this.jobIsRunning())
    this.$router.push('payment-code-verify').then();
  }

  TransferClick() {
    this.$router.push('transfer').then();
  }

  ServiceReceiverClick() {
    if(!this.jobIsRunning())
    this.$router.push('payment-select').then();
  }

  menuClick() {

  }
}


